import { render, staticRenderFns } from "./AddSubProductToBasketButton.vue?vue&type=template&id=4a7e343f&"
import script from "./AddSubProductToBasketButton.vue?vue&type=script&lang=js&"
export * from "./AddSubProductToBasketButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports